import { UserRole } from "components/Reports/reportAssets/assets";
import { useRole } from "./useRole";

export const useClassReadOnlyByRole = (isParent = false) => {
  const role = useRole();

  if (role === UserRole.CONTROLCENTER) {
    return isParent ? "readOnlyModeParent" : "readOnlyMode";
  }
  return "";
};
